import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

import selectNotAssignedList from './selectNotAssignedList';


// type Props = {
//   id: string, // id выбранного студента
// };

const enhance = compose(
  withTranslation('subs'),

  connect(
    (state, props) => ({
      unsubsData: selectNotAssignedList(state, props),
    })
  )
);

export default enhance;
